module.exports = __webpack_public_path__ + "img/jp-title.c587e5c3.png";